<ng-container *ngIf="image$ | async as image">

  <div class="image-viewer">

    <header class="image-viewer-header">

        <div
            class="image-viewer-name"
            [title]="getFileName(image.name)">
            {{ getFileName(image.name) }}
        </div>

    <div class="image-viewer-actions">

        <button
            type="button"
            class="image-viewer-action"
            aria-label="Baixar imagem"
            title="Baixar imagem"
            (click)="download(image)">

            <mat-icon svgIcon="file_download"></mat-icon>

        </button>

        <button
            type="button"
            class="image-viewer-action"
            aria-label="Fechar visualizador"
            title="Fechar"
            (click)="close()">

            <mat-icon svgIcon="close"></mat-icon>

        </button>

    </div>

    </header>

    <div class="image-viewer-content">

      <img
        crossorigin="anonymous"
        class="image-viewer-image"
        [src]="image.url"
        [alt]="image.name">

    </div>

  </div>

</ng-container>